export const ENTITY_SUBFIELDS_KEY = 'entitySubfields';

export const createSubfieldTranslationKey = (fieldPath: string): string => {
	return `${ENTITY_SUBFIELDS_KEY}.${fieldPath}`;
};
